export default __webpack_public_path__ + "static/cabin-basic-new-3-e20f405466d4382abb0ec79154e25452.jpg";